import { TextInput, useComputedColorScheme } from '@mantine/core';
import { useHotkeys } from '@mantine/hooks';
import { useActiveForm } from 'pages/claims/components/ClaimFormProvider';
import React, { useRef } from 'react';

interface ModalTextInputProps {
  label: string;
  required?: boolean;
  accessorKey: string;
  type?: string;
  hotkey?: string;
  disabled?: boolean;
  capitalizeFirst?: boolean;
}
export const ModalTextInput: React.FC<ModalTextInputProps> = React.memo(
  ({
    label,
    required = false,
    accessorKey,
    hotkey,
    disabled = false,
    capitalizeFirst = false,
  }) => {
    const computedColorScheme = useComputedColorScheme('dark');
    const color = computedColorScheme === 'dark' ? 'white' : 'black';
    const { form, prefix } = useActiveForm();
    const path = prefix ? `${prefix}.${accessorKey}` : accessorKey;
    const inputProps = form.getInputProps(path);

    const ref = useRef<HTMLInputElement>(null);

    useHotkeys([
      [
        hotkey || '',
        () => {
          if (ref.current) {
            ref.current.focus();
          }
        },
      ],
    ]);

    const handleBlur = () => {
      if (capitalizeFirst && inputProps.value) {
        const capitalizedValue =
          inputProps.value.charAt(0).toUpperCase() + inputProps.value.slice(1);
        form.setFieldValue(path, capitalizedValue);
      }
    };

    return (
      <TextInput
        key={path}
        radius={'md'}
        withAsterisk={required}
        size="md"
        label={label}
        c={color}
        ref={ref}
        disabled={disabled}
        {...inputProps}
        onBlur={capitalizeFirst ? handleBlur : inputProps.onBlur}
      />
    );
  }
);
